// extracted by mini-css-extract-plugin
module.exports = {"empty":"dmbc-base_empty-empty","message":"dmbc-base_empty-message","actions":"dmbc-base_empty-actions","noMargin":"dmbc-base_empty-noMargin"};